<div>
  <app-header (toggleSidebar)="sidebarExpanded = !sidebarExpanded"></app-header>
  <div class="wrapper">
    <app-sidebar-menu [isExpanded]="sidebarExpanded" (toggleSidebar)="sidebarExpanded = !sidebarExpanded"></app-sidebar-menu>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>